import Model from '@/models/Model'
import DrawerModel from './DrawerModel'
import GeologicTypeModel from './GeologicTypeModel'
import * as TYPE from '@/const.types'
import Vue from 'vue'

export default class SampleModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get name () {
    return this.get('attributes.name') || this.get('name') || this.get('attributes.drawer_name') || this.get('drawer_name') || 'NO NAME'
  }

  get subtitle () {
    return this.get('attributes.drawer_subtitle') || this.get('drawer_subtitle') || 'NO NAME'
  }

  get number () {
    return this.get('attributes.vid') || this.get('number')
  }

  get coverZoom () {
    return this.get('rel.photos.0.rel.field_image.attributes.url') || this.get('media.0.sample_search_desktop_big') || this.get('images.0.sample_search_desktop_big')
  }

  get coverThumbnail () {
    return this.get('rel.photos.0.rel.field_image.attributes.url') || this.get('media.0.sample_home_small') || this.get('images.0.sample_home_small') || this.get('images.0.sample_search_desktop_small')
  }

  get allImages () {
    const photos = this.get('rel.photos')
    const slides = []

    photos.map((photo) => {
      if (photo.rel.field_image.links.picture_cover_desktop) {
        slides.push({
          href: photo.rel.field_image.links.picture_cover_desktop.href,
          thin_section_photo: !!photo.attributes.thin_section_photo
        })
      }
    })

    return slides
  }

  get thumbnail () {
    return this.get('rel.photos.0.rel.field_image.links.picture_cover_desktop.href') || this.get('rel.photos.0.rel.thumbnail.links.picture_cover_desktop.href') || this.get('media.0.sample_home_small') || this.get('images.0.sample_home_small') || this.get('images.0.sample_search_desktop_small');
  }

  get type () {
    return this.get('type_of_sample') || this.get('type')
  }

  get drawer () {
    return this.has('rel.drawer') ? new DrawerModel(this.get('rel.drawer'), this._included) : null
  }

  get parent () {
    const mapType = new Map([
      [`sample--${TYPE.SAMPLE_MINERAL}`, 'attributes.hierarchical_mineral_classification'],
      [`sample--${TYPE.SAMPLE_FOSSIL}`, 'attributes.hierarchical_phylogenetic_group'],
      [`sample--${TYPE.SAMPLE_ROCK}`, 'attributes.hierarchical_rock_family'],
      [`sample--${TYPE.SAMPLE_ORE}`, 'attributes.hierarchical_ore_family']
    ])

    const t = mapType.get(this.type)
    const v = this.get(t)
    if (v) return Array.isArray(v) ? v[0] : v
    else return null
  }

  get geologicType () {
    const mapType = new Map([
      [`sample--${TYPE.SAMPLE_MINERAL}`, 'rel.mineral.rel.classification'],
      [`sample--${TYPE.SAMPLE_FOSSIL}`, 'rel.fossil.rel.phylogenetic_group'],
      [`sample--${TYPE.SAMPLE_ROCK}`, 'rel.rock.rel.rock_family'],
      [`sample--${TYPE.SAMPLE_ORE}`, 'rel.ore.rel.ore_family']
    ])

    const t = mapType.get(this.type)
    if (t && this.has(t)) {
      const gs = this.get(t)
      return Array.isArray(gs) ? gs.map((g) => new GeologicTypeModel(g, this._included)) : new GeologicTypeModel(gs, this._included)
    } else { return null }
  }

  get details () {
    return this.get('attributes.sample_details')
  }

  get prevEntity () {
    return this.get('attributes.prev_entity')
  }

  get nextEntity () {
    return this.get('attributes.next_entity')
  }

  get url () {
    const url = this.get('url')
    let path = this.get('url') || this.get('attributes.path')

    if (url) {
      return url
    }

    return path ? Vue.$tools.getURL(path) : this.get('href')
  }
}
